module.exports = __webpack_public_path__ + "img/title_left_bg.34bbd134.png";